import monkeyPatch from "./monkeyPatch.js";

/**
 * Erweitert alle Javascript-Sets um einen Satz von Hilfsmethoden (Monkeypatching).
 * FUCK YOU ES6-Standards-Kommitee! Warum ist das nicht Teil des Standards !?!?!?!?!?!?!
 */
monkeyPatch(Set.prototype, {

    /**
     * Convenience, Vereinheitlichung mit Array.includes
     */
    includes(element) {
        return this.has(element);
    },

    /**
     * Prüft, ob das Predicate für jedes Element true ergibt
     */
    every(predicate) {
        let t = true;
        this.forEach(x=>{
            t = t && predicate(x)
        });
        return t;
    },

    /**
     * Prüft, ob das Predicate für wenigstens ein Element true ergibt
     */
    some(predicate) {
        let t = false;
        this.forEach(x=>{
            t = t || predicate(x)
        });
        return t;
    },

    /**
     * Prüft, ob dieser Set einen anderen enthält
     */
    containsSet(other) {
        if (other) {
            return other.every(x=>this.has(x));
        }
        return true;
    },

    /**
     * Prüft, ob zwei Sets gleich sind
     */
    equals(other) {
        return other && this.size === other.size && this.containsSet(other);
    },

    /**
     * Gibt einen Set zurück, der nur Elemente enthält, für die Predicate true ist.
     */
    filter(predicate) {
        const result = new Set();
        this.forEach(x=>{
            if (predicate(x)) {
                result.add(x);
            }
        });
        return result;
    },

    /**
     * Gibt die Schnittmenge mit einem anderen Set zurück
     */
    intersection(other) {
        if (other) {
            return this.filter(x => other.has(x));
        }
        return new Set();
    },

    /**
     * Gibt die Differenz zu einem anderen Set zurück
     */
    difference(other) {
        if (other) {
            return this.filter(x => !other.has(x));
        }
        return new Set(this);
    },

    /**
     * Gibt die Vereiningung mit einem anderen Set zurück
     */
    union(other) {
        const result = new Set();
        this.forEach(x=>result.add(x));
        if (other) {
            other.forEach(x=>result.add(x));
        }
        return result;
    },

    /**
     * fügt alle Elemente einer anderen Collection zum Set hinzu, und verändert diesen Set.
     */
    addAll(other) {
        if (other) {
            other.forEach(x=>this.add(x));
        }
    },

    /**
     * Entfernt alle Elemente aus diesem Set einer anderen Collection
     */
    deleteAll(other) {
        if (other) {
            other.forEach(x=>this.delete(x));
        }
    },

    /**
     * gibt das erste Element des Sets zurück, oder undefined
     */
    first() {
        return this.values().next().value;
    },

    /**
     * gibt das erste Element des Sets zurück, für das predicate(Element) true ist, oder null
     */
    find(predicate) {
        for (let v in this.values()) {
            if (predicate(v)) {
                return v;
            }
        }
        return null;
    },

    /**
     * wie Array.join
     * @param delimiter
     * @returns {string}
     */
    join(delimiter) {
        return Array.from(this).join(delimiter);
    },

    /**
     * ruf mapper(value,key) für jeden Eintrag auf und baut ein Set mit den Rückgabewerten auf
     */
    map(mapper) {
        const list = [];
        this.forEach((value,key)=>{
            list.push(mapper(value,key));
        });
        return new Set(list);
    },
});

/**
 * Welcher Vollpfosten hatte diese glorreiche Idee: array.length aber set.size???????
 * Sowas ist einfach nur kognitiver Müll!
 * Das hier ist zwar nicht so performant, aber solche Fehler sind teilweise schwer zu finden,
 * daher lieber Bugfreiheit.
 * for the record: https://stackoverflow.com/questions/35038750/why-do-javascript-sets-maps-use-size-instead-of-length
 * Idioten!
 */

if (!Object.getOwnPropertyDescriptor(Set.prototype,'length')) {
    Object.defineProperty(Set.prototype, "length", {
        get() {
            return this.size;

        }
    });
}
